import React, { useEffect, useLayoutEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Calendar } from "primereact/calendar";
import ErrorMessages from "helper/errorMessages";
import { dbFirestore } from "helper/config/firebase";
import RoutingPaths from "helper/routingPath";
import ToastMessages from "helper/toastMessages";
import TableName from "helper/tableName/tableName";
import CommonHeadings from "helper/constant/headings";
import ButtonLabels from "helper/constant/buttonLabels";
import BottomButtons from "components/buttons/bottomButtons";
import HeadingComponent from "components/headingComponent";
import {
  addDoc,
  and,
  collection,
  doc,
  getDocs,
  or,
  query,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import moment from "moment";
import AsyncSelect from "react-select/async";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dateformat from "helper/constant/timeFormat";
import { InputNumber } from "primereact/inputnumber";

function AddDemoStudents() {
  const location = useLocation(); //  used to access the current location object which gives info about URL like strings, path etc
  const [isSubmitted, setIsSubmitted] = useState(false); // when we submit the form, it will check the error
  const [demoDate, setDemoDate] = useState(null); // only use in the primereact calendar when we select the demo date
  const [demoStudentsHeading, setDemoStudentsHeading] = useState(
    CommonHeadings.demoAddHeading
  );
  const [buttonLabel, setButtonLabel] = useState(ButtonLabels.saveLabel);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [demoStudentsID, setDemoStudentsID] = useState();
  const navigate = useNavigate();

  const [demoStudents, setDemoStudents] = useState({
    // set input values
    name: "",
    email: "",
    phone: null,
    address: "",
    demo_date: "",
    demo_date_num: null,
    selected_course_id: null,
  });

  const [errors, setErrors] = useState({
    name: "",
    demo_date: "",
    selected_course_id: "",
  });

  // MARK: Use Effect Method
  useEffect(() => {
    fetchCoursesApi();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //Use Layout Method
  useLayoutEffect(() => {
    document.title = location.state
      ? CommonHeadings.demoEditHeading
      : CommonHeadings.demoAddHeading;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //   when we enter any value that's set in the setDemoStudents() and change the input afer submitting like blank all the inputs
  const inputChange = (e) => {
    var { name, value } = e.target;

    if (name === "demo_date") {
      value = moment(value).format(Dateformat.YYYYMMDD);
    }

    setDemoStudents({
      ...demoStudents,
      [name]: value,
    });
  };

  const courseSelect = (e) => {
    const name = "selected_course_id";

    setDemoStudents({
      ...demoStudents,
      [name]: e,
    });
  };

  const validateForm = (data) => {
    const errors = {};
    if (!data.name) {
      errors.name = ErrorMessages.name;
    }
    if (!data.demo_date) {
      errors.demo_date = ErrorMessages.demoDate;
    }
    if (!data.selected_course_id) {
      errors.selected_course_id = ErrorMessages.demoCategory;
    }

    return errors;
  };

  // MARK: button
  const tapOnSave = () => {
    const newErrors = validateForm(demoStudents);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading1(true);
      if (location.state) {
        updateDemoStudentsApi();
      } else {
        writeDemoStudentsApi();
      }
    }
  };

  // this function is working when we submit the form by clicking on save andnext button
  const tapOnSaveNext = () => {
    const newErrors = validateForm(demoStudents);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading2(true);
      writeDemoStudentsApi(true);
    }
  };

  // MARK: edit data function
  async function setEditDemoStudentsUI(arrayCourse) {
    const myDate = moment(
      location.state.demo_date,
      Dateformat.YYYYMMDD
    ).toDate();
    setDemoDate(myDate);

    var courseObject = arrayCourse.find(function (course) {
      return course.id === location.state.selected_course_id;
    });

    setDemoStudents((prevState) => ({
      ...prevState,
      name: location.state.name,
      email: location.state.email,
      phone: location.state.phone,
      address: location.state.address,
      demo_date: location.state.demo_date,
      selected_course_id: courseObject,
    }));

    setDemoStudentsHeading(CommonHeadings.demoEditHeading);
    setButtonLabel(ButtonLabels.updateLabel);
    setDemoStudentsID(location.state.id);
  }

  // MARK: payload function
  function payload() {
    const createdAt = Timestamp.fromDate(new Date()).toMillis();
    const object = {
      ...demoStudents,
      created_at: createdAt,
      updated_at: null,
    };

    const dateOnly = Timestamp.fromDate(new Date(object.demo_date)).toMillis();
    object.demo_date_num = dateOnly;

    object.name = demoStudents.name.toLowerCase();
    object.email= demoStudents.email.toLowerCase();
    object.address= demoStudents.address.toLowerCase();

    return object;
  }

  // MARK: reset values function
  function ResetValues() {
    setDemoStudents({
      name: "",
      email: "",
      phone: "",
      address: "",
      demo_date: "",
      demo_date_num: "",
      selected_course_id: "",
    });
  }

  // MARK: API
  async function fetchCoursesApi() {
    let q = query(collection(dbFirestore, TableName.courses));

    const querySnapshot = await getDocs(q);
    const a = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));

    //  edit functionality
    if (location.state) {
      setEditDemoStudentsUI(a);
    }
  }

  // write API
  async function writeDemoStudentsApi(edit) {
    const writePayload = payload();
    writePayload.selected_course_id = demoStudents.selected_course_id.id;

    try {
      await addDoc(collection(dbFirestore, TableName.demostudents), {
        ...writePayload,
      });

      if (edit) {
        toast.success(ToastMessages.demoStudentsAdd);
        ResetValues();
        setTimeout(() => {
          setLoading2(false);
          // when user press on save + next
          navigate(RoutingPaths.addDemoStudents);
          ResetValues();
        }, 600);
      } else {
        toast.success(ToastMessages.demoStudentsAdd);
        setTimeout(() => {
          setLoading1(false);
          navigate(RoutingPaths.demoStudentsList);
        }, 600);
      }
    } catch (error) {
      setLoading1(false); // hide
      setLoading2(false);
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // update API
  async function updateDemoStudentsApi() {
    const updatedPayload = payload();
    updatedPayload.created_at = location.state.created_at;
    updatedPayload.updated_at = Timestamp.fromDate(new Date()).toMillis();
    updatedPayload.selected_course_id = demoStudents.selected_course_id.id;

    try {
      await updateDoc(
        doc(dbFirestore, TableName.demostudents, demoStudentsID),
        {
          ...updatedPayload,
        }
      );

      toast.success(ToastMessages.demoStudentsUpdated);

      setTimeout(() => {
        setLoading1(false);
        navigate(RoutingPaths.demoStudentsList);
      }, 600);
    } catch (error) {
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // MARK: course list fetch from the firebase
  const courseList = async (searchText) => {
    let q = query(
      collection(dbFirestore, TableName.courses),
      or(
        // query as-is:
        and(
          where("name", ">=", searchText),
          where("name", "<=", searchText + "\uf8ff")
        ),
        and(
          where(
            "name",
            ">=",
            searchText.charAt(0).toUpperCase() + searchText.slice(1)
          ),
          where(
            "name",
            "<=",
            searchText.charAt(0).toUpperCase() + searchText.slice(1) + "\uf8ff"
          )
        )
      )
    );
    const querySnapshot = await getDocs(q);

    const s = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      id: docs.data().id,
      name: docs.data().name,
    }));

    return s;
  };

  //course name which show in the dropdown
  function courseName(e) {
    return e["name"];
  }

  //  MARK: UI data
  const rowStudentsData = [
    {
      name: "name",
      classNameLabel: "input__valid",
      value: demoStudents.name,
      change: inputChange,
      type: "text",
      label: "Name",
      placeholder: "Enter your name",
      error: errors.name,
    },
    {
      name: "email",
      value: demoStudents.email,
      change: inputChange,
      id: "email",
      type: "text",
      label: "Email",
      placeholder: "Enter your email",
    },
    {
      name: "phone",
      value: demoStudents.phone,
      change: inputChange,
      id: "phone",
      type: "tel",
      label: "Contact Number",
      placeholder: "Enter your contact number",
      length: 10,
    },
    {
      name: "demo_date",
      classNameLabel: "input__valid",
      value: demoDate,
      change: inputChange,
      placeholder: "dd/mm/yyyy",
      dateFormat: "dd/mm/yy",
      label: "Demo Date",
      error: errors.demo_date,
    },
  ];

  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <HeadingComponent
            classname="mb-4"
            headingName={demoStudentsHeading}
          />
          {/* p-fluid is the primereact class */}
          <div className="p-fluid">
            <div className="row modules__row">
              {rowStudentsData.map((col) => (
                <div className="col-12 col-md-6">
                  <label htmlFor={col.name} className={col.classNameLabel}>
                    {col.label}
                  </label>
                  {col.type === "text" && (
                    <InputText
                      name={col.name}
                      value={col.value}
                      onChange={col.change}
                      id={col.name}
                      type={col.type}
                      placeholder={col.placeholder}
                      maxLength={col.length}
                    />
                  )}

                  {col.type === "tel" && (
                    <InputNumber
                      name={col.name}
                      placeholder={col.placeholder}
                      inputId={col.name}
                      value={col.value}
                      onValueChange={col.change}
                      useGrouping={false}
                      maxLength={10}
                    />
                  )}
                  {!col.type && (
                    <Calendar
                      name={col.name}
                      value={col.value}
                      onChange={col.change}
                      showIcon
                      showButtonBar
                      placeholder={col.placeholder}
                      dateFormat={col.dateFormat}
                    />
                  )}

                  {isSubmitted && (
                    <small id={col.name} className="p-error">
                      {col.error}{" "}
                    </small>
                  )}
                </div>
              ))}

              <div className="col-12 col-md-6">
                <label htmlFor="address">Address</label>
                <InputTextarea
                  name="address"
                  value={demoStudents.address}
                  onChange={inputChange}
                  id="address"
                  placeholder="Enter your address"
                  rows={3}
                  cols={30}
                />
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="selected_course_id" className="input__valid">
                  Select Demo course
                </label>

                <AsyncSelect
                  classNamePrefix="course__dropdown"
                  maxMenuHeight={170}
                  isClearable
                  cacheOptions
                  loadOptions={courseList}
                  value={demoStudents.selected_course_id}
                  defaultOptions
                  getOptionLabel={(e) => courseName(e)}
                  getOptionValue={(e) => e}
                  onChange={courseSelect}
                />
                {isSubmitted && (
                  <small id="selected_course_id" className="p-error">
                    {errors.selected_course_id}{" "}
                  </small>
                )}
              </div>
            </div>
          </div>

          <BottomButtons
            label={buttonLabel}
            save={tapOnSave}
            loading1={loading1}
            saveNext={tapOnSaveNext}
            loading2={loading2}
          />
          <ToastContainer />
        </div>
      </div>
    </div>
  );
}

export default AddDemoStudents;
